<template>
  <a-icon :type="iconType" :style="iconStyle" @click="handleClick" />
</template>

<script>
export default {
  name: 'ChIcon',
  props: {
    type: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    customStyle: {
      type: [String, Object],
      default: ''
    }
  },
  computed: {
    iconType() {
      const typeMap = {
        'icon-add': 'plus',
        'icon-close': 'close'
      };
      return typeMap[this.type] || this.type;
    },
    iconStyle() {
      const styles = {};
      if (this.color) {
        styles.color = this.color;
      }
      if (typeof this.customStyle === 'string') {
        Object.assign(styles, this.parseStyleString(this.customStyle));
      } else if (typeof this.customStyle === 'object') {
        Object.assign(styles, this.customStyle);
      }
      return styles;
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
    parseStyleString(styleStr) {
      const styles = {};
      if (!styleStr) return styles;
      styleStr.split(';').forEach(rule => {
        const [key, value] = rule.split(':');
        if (key && value) {
          const camelCaseKey = key.trim().replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
          styles[camelCaseKey] = value.trim();
        }
      });
      return styles;
    }
  }
};
</script>
